var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { Component, EventEmitter, HostListener, Inject, Input, Output } from '@angular/core';
import { CreateOrUpdateViewDto } from '../../../../../shared/service-proxies/service-proxies';
import * as _ from 'lodash';
import { Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { ConfigureComponentBase } from '../../../../../shared/configure-component-base';
import { DiagramEx } from '../../../diagram/diagram-ex';
import { DESIGNER_SETTINGS_SERVICE } from '../../settings/designer-settings.service';
import { ConfigureViewSizeChangedArgs } from '../../shared/configure-view-size-changed.args';
import { ConfigureViewType } from '../../shared/configure-view-type';
import { DesignerConsts } from '../../shared/designer-consts';
import { ViewSettingsModalComponent } from '../view-setting/view-settings-modal.component';
var ConfigureViewComponent = /** @class */ (function (_super) {
    __extends(ConfigureViewComponent, _super);
    function ConfigureViewComponent(injector, templateService, layerService, designerSettingsService, configureViewProxyService, modalService) {
        var _this = _super.call(this, injector) || this;
        _this.injector = injector;
        _this.templateService = templateService;
        _this.layerService = layerService;
        _this.designerSettingsService = designerSettingsService;
        _this.configureViewProxyService = configureViewProxyService;
        _this.modalService = modalService;
        _this.modifiedChange = new EventEmitter();
        _this.elementDoubleClicked = new EventEmitter();
        _this.savedCallback = function () {
            _this.modified = false;
            _this.currentDiagram.isModified = false;
        };
        _this.viewSizeChangedCallback = function (args) {
            if (_this.args.type !== args.viewType) {
                return;
            }
            if (args.viewType === ConfigureViewType.PopView && _this.args.viewId !== args.viewId) {
                return;
            }
            _this.currentDiagram.resize(args.width, args.height);
        };
        _this.setViewSettingsCallback = function (view) {
            if (view.id === _this.args.viewId) {
                _this.showViewSettings();
            }
        };
        _this.setViewConfiguresModelCallback = function (viewConfigure) {
            if (_this.args.viewId === viewConfigure.id) {
                if (viewConfigure.configure) {
                    _this.currentDiagram.model = DiagramEx.getDiagramModel(viewConfigure.configure);
                }
            }
        };
        return _this;
    }
    Object.defineProperty(ConfigureViewComponent.prototype, "modified", {
        get: function () {
            if (!this.args) {
                return false;
            }
            return this.args.modified;
        },
        set: function (value) {
            this.args.modified = value;
            this.modifiedChange.emit(this.args.modified);
            abp.event.trigger('designer:view-modified', value);
        },
        enumerable: true,
        configurable: true
    });
    ConfigureViewComponent.prototype.ngOnInit = function () {
        abp.event.on('designer:saved', this.savedCallback);
        abp.event.on(DesignerConsts.events.viewSizeChanged, this.viewSizeChangedCallback);
        abp.event.on('designer:set-view-settings', this.setViewSettingsCallback);
        abp.event.on(DesignerConsts.events.modelChanged, this.setViewConfiguresModelCallback);
    };
    ConfigureViewComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.currentDiagram = new DiagramEx('View-' + this.args.viewId, this.args.width, this.args.height, this.args.diagramModel, this.templateService, this.layerService, this.args.type, this.lc('PopViewDoesNotSupportVideo'));
        this.refreshSize();
        this.currentDiagram.addDiagramListener('ObjectDoubleClicked', function (e) { return _this.elementDoubleClicked.emit(e); });
        this.currentDiagram.addDiagramListener('Modified', function () {
            _this.modified = _this.currentDiagram.isModified;
        });
        this.currentDiagram.addDiagramListener('BackgroundDoubleClicked', function (e) {
            _this.showViewSettings();
        });
        this.subscription = new Subscription();
        this.subscription.add(this.designerSettingsService.isShowGridChange.subscribe(function (isShowGrid) {
            _this.currentDiagram.isShowGrid = isShowGrid;
            _this.currentDiagram.isGridSnapEnabled = isShowGrid && _this.designerSettingsService.isGridSnapEnabled;
        }));
        this.subscription.add(this.designerSettingsService.isGridSnapEnabledChange.subscribe(function (isGridSnapEnabled) {
            _this.currentDiagram.isGridSnapEnabled = _this.designerSettingsService.isShowGrid && isGridSnapEnabled;
        }));
        this.subscription.add(this.designerSettingsService.isGuidelineSnapEnabledChange.subscribe(function (isGuidelineSnapEnabled) {
            _this.currentDiagram.isGuidelineSnapEnabled = isGuidelineSnapEnabled;
        }));
        if (this.args.showSettingsWhenInited) {
            this.showViewSettings();
        }
        document.addEventListener('keyup', function () {
            var isGridSnapEnabled = _this.designerSettingsService.isGridSnapEnabled;
            var isGuidelineSnapEnabled = _this.designerSettingsService.isGuidelineSnapEnabled;
            if (_this.currentDiagram.lastInput.key === 'V') {
                _this.designerSettingsService.isGridSnapEnabled = false;
                _this.designerSettingsService.isGuidelineSnapEnabled = false;
                _this.commandHandler.pasteSelection();
                _this.designerSettingsService.isGridSnapEnabled = isGridSnapEnabled;
                _this.designerSettingsService.isGuidelineSnapEnabled = isGuidelineSnapEnabled;
                _this.currentDiagram.lastInput.key = undefined;
            }
        });
        // 表格元件阻止右击默认事件
        document.getElementById('contextMenu' + this.args.viewId).addEventListener('contextmenu', function (e) {
            e.preventDefault();
            return false;
        }, false);
    };
    ConfigureViewComponent.prototype.ngOnDestroy = function () {
        abp.event.off('designer:saved', this.savedCallback);
        abp.event.off(DesignerConsts.events.viewSizeChanged, this.viewSizeChangedCallback);
        abp.event.off('designer:set-view-settings', this.setViewSettingsCallback);
        abp.event.off(DesignerConsts.events.modelChanged, this.setViewConfiguresModelCallback);
        this.subscription.unsubscribe();
    };
    ConfigureViewComponent.prototype.onResize = function () {
        this.refreshSize();
    };
    ConfigureViewComponent.prototype.refreshSize = function () {
        var bodyheight = $('body').height();
        var tabTop = $('.diagram').offset().top + 28;
        var height = bodyheight - tabTop;
        this.currentDiagram.div.style.height = height + 'px';
    };
    ConfigureViewComponent.prototype.showViewSettings = function () {
        var _this = this;
        var view = this.args;
        var viewSettingGoModel = _.cloneDeep(this.currentDiagram.getViewSettings());
        var viewSettings = {
            background: viewSettingGoModel.background,
            general: {
                width: view.width,
                height: view.height,
                name: view.name,
                viewType: view.type,
            }
        };
        var generalSetting = viewSettings.general;
        if (view.type === ConfigureViewType.PopView) {
            generalSetting.popViewSetting = viewSettingGoModel.popup;
        }
        var args = {
            configureId: this.args.configureId,
            viewId: view.viewId,
            data: viewSettings,
        };
        var modalRef = this.modalService.show(ViewSettingsModalComponent, {
            initialState: { args: args },
            backdrop: 'static', class: 'configure-pop-view-modal'
        });
        var onClosedSub = modalRef.content.onClosed.subscribe(function (result) {
            if (!result) {
                onClosedSub.unsubscribe();
                modalRef.hide();
                return;
            }
            var viewSetting = {
                background: result.background
            };
            if (generalSetting.viewType === ConfigureViewType.PopView) {
                viewSetting.popup = result.general.popViewSetting;
            }
            _this.currentDiagram.setViewSettings(viewSetting);
            _this.saveViewSettings(result).then(function (r) {
                if (r) {
                    onClosedSub.unsubscribe();
                    modalRef.hide();
                }
            });
        });
    };
    ConfigureViewComponent.prototype.saveViewSettings = function (result) {
        var _this = this;
        var popViewSaveDto = new CreateOrUpdateViewDto();
        popViewSaveDto.configure = this.currentDiagram.model.toJson();
        popViewSaveDto.configureId = this.args.configureId;
        popViewSaveDto.height = result.general.height;
        popViewSaveDto.viewType = this.args.type.valueOf();
        popViewSaveDto.width = result.general.width;
        popViewSaveDto.name = result.general.name;
        popViewSaveDto.id = this.args.viewId;
        abp.ui.setBusy();
        return new Promise(function (resolve, reject) {
            _this.configureViewProxyService.createOrUpdateView(popViewSaveDto).pipe(finalize(function () { return abp.ui.clearBusy(); }))
                .subscribe(function () {
                var viewSizeChanged = popViewSaveDto.height !== _this.args.height || popViewSaveDto.width !== _this.args.width;
                _this.args.height = popViewSaveDto.height;
                _this.args.name = popViewSaveDto.name;
                _this.args.width = popViewSaveDto.width;
                if (viewSizeChanged) {
                    var args = new ConfigureViewSizeChangedArgs(_this.args.type, popViewSaveDto.height, popViewSaveDto.width, _this.args.viewId);
                    abp.event.trigger(DesignerConsts.events.viewSizeChanged, args);
                }
                resolve(true);
                abp.notify.success(_this.l('OperationSuccessfully'));
                abp.event.trigger('designer:view-list:refresh');
            }, function (err) {
                resolve(false);
            });
        });
    };
    ConfigureViewComponent.prototype.cxcommand = function (value) {
        if (this.commandHandler) {
            this.commandHandler.cxcommand(value);
        }
    };
    __decorate([
        Input()
    ], ConfigureViewComponent.prototype, "args", void 0);
    __decorate([
        Input()
    ], ConfigureViewComponent.prototype, "commandHandler", void 0);
    __decorate([
        Output()
    ], ConfigureViewComponent.prototype, "modifiedChange", void 0);
    __decorate([
        Output()
    ], ConfigureViewComponent.prototype, "elementDoubleClicked", void 0);
    __decorate([
        HostListener('window:resize', [])
    ], ConfigureViewComponent.prototype, "onResize", null);
    ConfigureViewComponent = __decorate([
        Component({
            selector: 'configure-view',
            template: "<div> <div [id]=\"'View-'+ args.viewId\" class=\"diagramContainer\"></div> <div [id]=\"'contextMenu' + args.viewId\" class=\"contextMenu\"> <ul> <li class=\"addRow\" (click)=\"cxcommand('addRow')\"> <a href=\"javascript:;\">{{lc(\"AddRow\")}}</a> </li> <li class=\"addCol\" (click)=\"cxcommand('addCol')\"> <a href=\"javascript:;\">{{lc(\"AddColumn\")}}</a> </li> <li class=\"deleteRow\" (click)=\"cxcommand('deleteRow')\"> <a href=\"javascript:;\">{{lc(\"DeleteRow\")}}</a> </li> <li class=\"deleteCol\" (click)=\"cxcommand('deleteCol')\"> <a href=\"javascript:;\">{{lc(\"DeleteColumn\")}}</a> </li> </ul> </div> </div>",
            styles: [".design-designer{ @titleBackground: #f4f4f4; @titleHeight: 28px; @titlePadding: 0 10px; ul.windowUl { padding: 0; list-style: none; } .screenTitle a { text-decoration: none; display: inline-block; height: 20px; cursor: pointer; width: 20px; background-image: url(\"/assets/common/images/configure/toolbar.png\"); } .levelSpacing { background-position: -40px -60px; } .levelSpacing:hover { background-position: 0px -60px; } .verticalSpacing { background-position: -100px -60px; } .verticalSpacing:hover { background-position: -60px -60px; } .aequilatus { background-position: -160px -60px; } .aequilatus:hover { background-position: -120px -60px; } .accordant { background-position: -220px -60px; } .accordant:hover { background-position: -180px -60px; } .large { background-position: -40px -80px; } .large:hover { background-position: 0px -80px; } .homochromy { background-position: -100px -80px; } .homochromy:hover { background-position: -60px -80px; } .topFloor { background-position: -160px -80px; } .topFloor:hover { background-position: -120px -80px; } .bottomFloor { background-position: -220px -80px; } .bottomFloor:hover { background-position: -180px -80px; } .upperFloor { background-position: -40px -100px; } .upperFloor:hover { background-position: 0px -100px; } .nextFloor { background-position: -100px -100px; } .nextFloor:hover { background-position: -60px -100px; } .top { background-position: 80px -80px; } .top:hover { background-position: 120px -80px; } .bottom { background-position: 20px -80px; } .bottom:hover { background-position: 60px -80px; } .prev { background-position: -40px -100px; } .prev:hover { background-position: 0px -100px; } .next { background-position: -100px -100px; } .next:hover { background-position: -60px -100px; } .contentBox { position: relative; overflow: hidden; width: 100%; } .windowsList { float: left; width: 220px; min-height: 500px; background: #f4f4f4; } .windowBox { border: solid 1px gray; } .padding { padding: 10px 0; } .floatRight { position: absolute; right: 0; display: inline-block; } .span { cursor: pointer; display: inline-block; height: 28px; width: 28px; } .itemList { position: relative; line-height: 24px; padding: 0 10px; } .itemList:hover { cursor: pointer; color: #000; background: #dae8ff; } .selected { background: #3695ff; color: #fff; } .configTitle { height: @titleHeight; padding: @titlePadding; background-color: @titleBackground; line-height: @titleHeight; color: #666; } @media (max-width:886px){ .diagram { top: 119px !important; } } @media (max-width:527px){ .diagram { top: 185px !important; } } .diagram { position: absolute; right: 0; top: 82px; left: 220px; bottom: 0; background-color: #bbb; .tab-content{ overflow: auto; } } .diagramContainer{ position: relative; } .contextMenu { z-index: 10001; position: absolute; left: 5px; background-color: #ffffff; display: none; font-size: 12px; font-family: sans-serif; font-weight: bold; box-shadow: 0 0 5px #666; } .contextMenu ul { list-style: none; top: 0; left: 0; margin: 0; padding: 0; } .contextMenu li a { position: relative; min-width: 60px; display: inline-block; padding: 6px; text-decoration: none; cursor: pointer; font-size: 12px; color: #666; font-weight: initial; } .contextMenu li:hover { background: #dae8ff; } .contextMenu li ul li { display: none; } .contextMenu li ul li a { position: relative; min-width: 60px; padding: 6px; text-decoration: none; cursor: pointer; } .contextMenu li:hover ul li { display: block; margin-left: 0px; margin-top: 0px; } } "]
        }),
        __param(3, Inject(DESIGNER_SETTINGS_SERVICE))
    ], ConfigureViewComponent);
    return ConfigureViewComponent;
}(ConfigureComponentBase));
export { ConfigureViewComponent };
